<template>
  <div class="page-wrapper pb-24 lg:pb-32">
    <MarkupSectionHeaderH1
      :config-data="{
        TitleFirstRow: modifiedConfigData.HeaderFirstRow.Title,
        TitleStyle: modifiedConfigData.HeaderFirstRow.TitleStyle,
      }"
    >
    </MarkupSectionHeaderH1>

    <MarkupSectionText
      v-if="modifiedConfigData.Ingress.Text"
      class="mt-16 md:mt-24"
      :config-data="modifiedConfigData.Ingress"
    ></MarkupSectionText>
  </div>

  <div class="page-wrapper pt-24 pb-8 lg:pb-16">
    <MarkupFilterSection :config-data="modifiedConfigData.Filter" />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    Header: {
      Text?: string;
    };
    Ingress: {
      Text?: string;
    };
  };
}

const props = defineProps<Props>();

const modifiedConfigData = {
  HeaderFirstRow: {
    Title: props.configData.Header.Text ?? 'Tillbehör',
    TitleStyle: 'boxed',
  },
  Ingress: {
    Text: props.configData.Ingress?.Text ?? '',
  },
  Filter: {
    Placeholder: 'Sök tillbehör...',
    DrawerDescription: 'Här kan du välja vilka tillbehör du vill se.',
  },
};
</script>

<style></style>
